export enum EstimateRowType {
    text = 0,
    cost,
    subtotal,
    total,
    markup,
    tax
}


// WEBPACK FOOTER //
// ./ClientApp/services/state/estimateRowType.ts